<template>
  <div style="margin: 10px">
    <v-form>
      <v-card>
        <div class="headline dialog-header" v-if="showDialogHeader">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px"
            >{{ $t(formName) }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-tabs slider-color="white" style="padding: 10px">
            <v-tabs-slider color="#2196F3"></v-tabs-slider>
            <v-tab
                v-for="tab of tabs"
                :key="tab.index"
                @click="selectTab(tab.id)"
            >
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <v-layout wrap>
            <v-flex xs12 sm12 md4>
              <div style="padding: 20px 10px">
                <p class="font-weight-bold">
                  Số đề nghị:
                  {{ createItem.exportNumber }}
                </p>
                <p class="font-weight-bold">
                  Vụ nuôi: {{ cropCode }}
                </p>
                <p class="font-weight-bold">
                  Người nuôi: {{ famerName }}
                </p>
                <p class="font-weight-bold">
                  Trạng thái:
                  <span v-if="!isExported" style="color: #d9d900">Chưa xuất kho</span>
                  <span v-else style="color: green">Đã xuất kho</span>
                </p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <table class="lstTable">
                <tr>
                  <th >
                    {{ $t("lang.material.materialType") }}
                  </th>
                  <th>Tên vật tư</th>
                  <th width="100">Đơn vị</th>
                  <th width="100">Tồn kho</th>
                  <th>Đề nghị xuất</th>
                </tr>

                <template v-for="(item, index) in lstMaterial">
                  <tr
                      v-if="item.row === 0"
                      :key="'mat' + index"
                  >
                    <td style="font-weight: bold">
                      {{ item.typeName }}
                    </td>
                    <td colspan="7">Không có vật tư</td>
                  </tr>
                  <tr v-else :key="'mat' + index">
                    <td
                        :rowspan="item.row"
                        v-if="item.row != undefined && parseInt(item.row) > 0"
                        style="font-weight: bold"
                    >
                      {{ item.typeName }}
                    </td>
                    <td>{{ item.materialName }}</td>
                    <td style="text-align: center">
                      {{ item.unit }}
                    </td>
                    <td style="text-align: center">
                      {{ item.inventory }}
                    </td>
                    <td style="text-align: center">
                      {{ item.quantity }}
                    </td>
                  </tr>
                </template>
              </table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              v-if="exportEnd"
              color="warning"
              @click="onEnding"
              :disabled="loading"
          >
            {{ $t("Kết thúc") }}
          </v-btn>
          <v-btn
              v-if="allowSave"
              color="primary"
              @click="onSavePrint"
              :disabled="loading"
          >
            {{ $t("Xác nhận và in") }}
          </v-btn>
          <v-btn
              v-if="allowSave"
              color="success"
              @click="onSave"
              :disabled="loading"
          >
            {{ $t("Xác nhận") }}
          </v-btn>
          <v-btn color="info" @click="onPrint" :disabled="loading">
            {{ $t("In phiếu") }}
          </v-btn>
          <v-btn
              color="warning"
              @click="onCancel"
              :disabled="loading"
          >
            {{ $t("lang.common.back") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import {message} from "../../../shared/message";
import {areaContants, roleConstants} from "@/constants";

export default {
  name: "WarehouseKeeperView",
  components: {IDatepicker},
  props: {
    exportId: {
      type: [String, Number],
      default: "-1",
    },
    showDialogHeader: {
      type: Boolean,
      default: true,
    },
    fromSummary: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      exportIdIn: "-1",
      formName: "Tạo đề nghị xuất kho",
      loading: false,
      cropCode: "",
      areaCode: "",
      famerName: "",
      lstMaterial: [],
      lstUser: [],
      lstMaterialPrice: [],
      lstInventory: [],
      exportRequest: "",
      allowSave: true,
      isExported: false,
      createItem: {
        areaId: 0,
        exportData: "",
        exportNumber: "",
        exportRequestId: 0,
        exportType: 0,
        session: 0,
        userCreateId: 0,
        userCreateName: "",
        warehouseId: '',
      },
      activeId: -1,
      tabs: [
        // {index: 0, id: 1, name: "1h"},
        // {index: 1, id: 2, name: "2h"},
      ],
    };
  },

  created() {
    // 2: Thủ kho
    const role = parseInt(this.$store.state.auth.user.role);
    if (role != 2 && role != 3) {
      //this.$router.push({path: "/exportRequest"});
      this.$router.push({ path: `/exportRequest`, query: this.$route.query });
    }
    this.getExportRequest(this.$route.params.id);
    this.createItem.userCreateId = this.$store.state.auth.user.userId;
    this.createItem.userCreateName = this.$store.state.auth.user.fullName;
  },
  computed: {
    exportEnd() {
      if (this.exportRequest != '' && this.exportRequest.exportedTime != null && this.exportRequest.status == 5) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {},

  methods: {
    onCancel() {
      this.$router.push({path: "/exportRequest"});
    },
    onSave(type) {
      if (confirm(this.$t("Bạn có muốn xác nhận không ?"))) {
        const createItem = this.createItem;
        const lstMaterial = this.lstMaterial;
        const activeId = this.activeId;
        // console.log(lstMaterial);
        // $.each(lstMaterial, function (k, v) {
        //     if (activeId == 1) {
        //         lstMaterial[k].quantityMaterial = v.quantityAm;
        //     } else {
        //         lstMaterial[k].quantityMaterial = v.quantityPm;
        //     }
        // });
        // console.log(lstMaterial);
        const total_export = lstMaterial.reduce(
            (n, { quantity }) => n + quantity,
            0
        );
        // console.log(total_export);
        if (!(total_export > 0)) {
            message.error("Không có vật tư xuất kho");
            return;
        }

        let rt = true;
        for(let i = 0; i< lstMaterial.length; i++){
            let obj = lstMaterial[i];
            const matPrice = this.lstMaterialPrice.find((v) => v.materialId === obj.materialId);
            if (matPrice != undefined) {
                obj.price = matPrice.averagePrice;
                obj.amount = parseFloat(obj.quantity) * parseFloat(obj.price);
            }

            if (parseFloat(obj.quantity) > parseFloat(obj.inventory)) {
                message.error("Số lượng xuất kho không được vượt quá số lượng tồn kho");
                rt = false;
            }
        }
        if(!rt){
          return;
        }
        // return;
        
        createItem.exportData = JSON.stringify(lstMaterial);
        createItem.session = activeId;
        const exportedTime = this.exportRequest.exportedTime + createItem.session + ',';
        createItem.exportSuccess = this.setExportSuccess(exportedTime);
        // console.log(createItem);
        // return;
        this.loading = true;

        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportWh/save",
                createItem
            )
            .then(
                (data) => {
                  if (data.success) {
                    message.success(
                        this.$t("lang.common.save_success")
                    );
                    this.exportRequest.exportedTime = exportedTime;
                    this.setAllowSave();
                    if(type == "print"){
                      this.onPrint();
                    }
                  } else {
                    message.error(this.$t(data.description));
                  }
                  this.loading = false;
                  if(type == "print"){
                    this.onPrint();
                  }

                  this.getWarehouseInventory(createItem.warehouseId);
                },
                (error) => {
                  this.loading = false;
                  console.log(error);
                }
            );
      }
    },
    onSavePrint() {
        this.onSave("print")
    },
    onEnding() {
      if (confirm(this.$t("Bạn có muốn xác nhận không ?"))) {
        // console.log(this.lstMaterial);
        const sefl = this;
        const lstMaterial = this.lstMaterial;
        let times = '';
        if (this.exportRequest.exportedTime != null) {
          times = this.exportRequest.exportedTime.split(',');
        }

        $.each(lstMaterial, function (k, v) {
          
          const timeAm = v.quantityAm;
          const timePm = v.quantityPm;

          if (timeAm.length > 0) {
            $.each(timeAm, function (k2, v2) {
              if (times != '' && !sefl.isInclude(times, v2.time)) {
                timeAm[k2].value = 0;
              }
            });
          }
          if (timePm.length > 0) {
            $.each(timePm, function (k2, v2) {
              if (times != '' && !sefl.isInclude(times, v2.time)) {
                timePm[k2].value = 0;
              }
            });
          }

          lstMaterial[k].quantityAm = timeAm;
          lstMaterial[k].quantityPm = timePm;

          const totalAm = timeAm.reduce((n, {value}) => n + (value !='' ? parseFloat(value) : 0), 0);
          const totalPm = timePm.reduce((n, {value}) => n + (value !='' ? parseFloat(value) : 0), 0);
          
          lstMaterial[k].total_export = Number((totalAm + totalPm).toFixed(2));
          lstMaterial[k].amount = lstMaterial[k].total_export * lstMaterial[k].price;
        });
        // console.log(lstMaterial);
        this.exportRequest.requestData = JSON.stringify(lstMaterial);
        // return;
        this.loading = true;

        axios
            .post(
                process.env.VUE_APP_API_URL + "/exportWh/exportEnd",
                this.exportRequest
            )
            .then(
                (data) => {
                  console.log(data);
                  this.loading = false;
                  if (data) {
                    message.success(this.$t("lang.common.save_success"));
                    this.exportRequest.status = 6;
                    this.setAllowSave();
                  }
                },
                (error) => {
                  this.loading = false;
                  console.log(error);
                }
            );
      }
    },
    onPrint() {
      axios({
        url: process.env.VUE_APP_API_URL + "/exportRequest/exportExcelWarehouseKeeper/" + this.activeId,
        method: "POST",
        data: this.exportRequest,
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Xuat_kho" + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    getExportRequest(exportId) {
      if (exportId != -1) {
        axios
            .post(
                process.env.VUE_APP_API_URL +
                "/exportRequest/search?pageSize=-1&page=-1",
                {exportId: exportId}
            )
            .then((data) => {
              if (data.items) {
                const exportRequest = data.items[0];
                // console.log(exportRequest);
                exportRequest.exportDate = moment(
                    String(exportRequest.exportDate)
                ).format("YYYY-MM-DD");
                this.getCrop(exportRequest.cropId);
                this.lstMaterial = JSON.parse(exportRequest.requestData);
                // console.log(this.lstMaterial);
                this.exportRequest = exportRequest;
                if (exportRequest.isExportAm == 1) {
                  this.allowSave = false;
                }

                this.createItem.exportNumber = exportRequest.requestNumber;
                this.createItem.exportRequestId = exportRequest.exportId;
                this.createItem.exportType = exportRequest.exportType;
                this.createItem.areaId = exportRequest.areaId;
                this.createItem.warehouseId = exportRequest.warehouseId;
                
                this.getMaterialPrice(exportRequest.warehouseId);
                this.setTabs();
                this.setAllowSave();
                this.getWarehouseInventory(exportRequest.warehouseId);
              }
            });
      }
    },
    getWarehouseInventory(warehouseId) {
        axios.post(
                process.env.VUE_APP_API_URL + "/warehouse/search?pageSize=-1&page=-1",
                {warehouseId: warehouseId}
            )
            .then((data) => {
                if (data.items) {
                    this.lstInventory = data.items;
                    this.setInventory();
                }
            });
    },
    setInventory() {
        const lstInventory = this.lstInventory;
        const lstMaterial = this.lstMaterial;
        if (lstInventory != undefined && lstMaterial != undefined) {
            for (let i = lstMaterial.length - 1; i >= 0; i--) {
                const inv = lstInventory.filter(function(o) {
                    return lstMaterial[i].materialId == o.materialId;
                });
                if (inv != undefined && inv[0] != undefined) {
                    lstMaterial[i].inventory = inv[0].quantity;
                }
            }
        }
        this.lstMaterial = lstMaterial;
    },
    getCrop(cropId) {
      axios
          .post(
              process.env.VUE_APP_API_URL +
              "/crop/search?pageSize=-1&page=-1",
              {cropId: cropId}
          )
          .then((data) => {
            if (data.items) {
              this.cropCode = data.items[0].code;
              this.getUser(data.items[0].users);
            }
          });
    },
    getUser(stringUser) {
      const uArr = stringUser.split(",");
      axios
          .post(process.env.VUE_APP_API_URL + "/user/list", {})
          .then((data) => {
            if (data.content.length > 0) {
              const lstUser = data.content;
              const famers = lstUser.filter(function (e) {
                return uArr.indexOf(String(e.userId)) != -1;
              });
              if (famers) {
                let listUser = "";
                $.each(famers, function (k, v) {
                  if (k == 0) {
                    listUser += v.fullName;
                  } else {
                    listUser += ", " + v.fullName;
                  }
                });
                this.famerName = listUser;
              }
            }
          });
    },
    selectTab(id) {
      this.activeId = id;
      this.createItem.exportNumber = this.exportRequest.requestNumber + '-' + id;
      this.setExportQuantity();
      this.setAllowSave();
    },
    setAllowSave() {
      let isExported = false;
      let allow = true;
      if (this.exportRequest.exportedTime != null) {
        const times = this.exportRequest.exportedTime.split(',');
        if (this.isInclude(times, this.activeId.toString())) {
          allow = false;
          isExported = true;
        }
      }
      if (this.exportRequest.status == 6) {
        allow = false;
      }
      this.allowSave = allow;
      this.isExported = isExported;
    },
    isInclude(times, activeId){
      let result = false;
      let times2 = "," + times + ",";
      let activeId2 = "," + activeId + ",";
      if(times2.includes(activeId2)){
        result = true;
      }
      return result
    },
    setTabs() {
      if (this.lstMaterial[0] != undefined) {
        const timeAm = this.lstMaterial[0].quantityAm;
        const timePm = this.lstMaterial[0].quantityPm;
        const tabs = [];
        let index = 0;
        if (timeAm.length > 0) {
          $.each(timeAm, function (k, v) {
            tabs.push({index: index++, id: v.time, name: v.time + 'H'});
          });
        }
        if (timePm.length > 0) {
          $.each(timePm, function (k, v) {
            tabs.push({index: index++, id: v.time, name: v.time + 'H'});
          });
        }
        if (tabs.length > 0) {
          this.activeId = tabs[0].id;
          this.createItem.exportNumber = this.exportRequest.requestNumber + '-' + tabs[0].id;
        }
        this.tabs = tabs;
        this.setExportQuantity();
      }
    },
    setExportQuantity() {
        const id = this.activeId;
        const lstMaterial = this.lstMaterial;

        $.each(lstMaterial, function (k, v) {
            let quantity = '';
            const quantityAm = v.quantityAm.find(function (e) {
                return e.time == id;
            });
            if (quantityAm != undefined) {
              quantity = quantityAm.value;
            } else {
                const quantityPm = v.quantityPm.find(function (e) {
                    return e.time == id;
                });
                if (quantityPm != undefined) {
                    quantity = quantityPm.value;
                }
            }
            lstMaterial[k].quantity = quantity >= 0 ? quantity : 0;
        });
        this.lstMaterial = lstMaterial;
    },
    setExportSuccess(times) {
      const self = this;
      const timeArr = times.split(",");
      let success = 1;
      $.each(this.tabs, function (k, v) {
        if (!self.isInclude(timeArr, v.id.toString())) {
          success = 0;
        }
      });
      return success;
    },
    getMaterialPrice(warehouseId) {
        axios.post(
            process.env.VUE_APP_API_URL + "/materialPrice/search?pageSize=-1&page=-1", {warehouseId: warehouseId}
        )
            .then((data) => {
                if (data.items) {
                    this.lstMaterialPrice = data.items;
                }
            });
    },
  },

  destroyed() {
  },
};
</script>
